// src/admin/components/Layout/AdminLayout.tsx
import React, { useState } from 'react';
import Navbar from '../Navbar/Navbar';
import Sidebar from '../Sidebar/Sidebar';
import GlobalReminderPopup from '../GlobalReminderPopup';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    // Updated Global Background Colors here
    <div className="min-h-screen transition-colors duration-300 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white"> 
      
      {/* 1. Navbar */}
      <Navbar onMenuToggle={toggleSidebar} />
      
      {/* 2. Sidebar */}
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      
      {/* 3. Global Notification Popup */}
      <GlobalReminderPopup />

      {/* 4. Main Content Area */}
      <main 
       className={`pt-16 min-h-screen lg:ml-80 transition-all duration-300`}
      >
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;